import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

export default makeStyles(
  (theme: Theme) =>
    createStyles({
      root: {
        display: 'flex',
        flexDirection: 'column',
        flex: 'auto',
        overflow: 'hidden',
      },
      toolbar: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        padding: theme.spacing(),
      },
      back: {
        textTransform: 'capitalize',
        '& .MuiButton-startIcon': {
          fontSize: 24,
          color: theme.palette.primary.main,
        }
      },
      content: {
        display: 'flex',
        flexDirection: 'column',
        padding: theme.spacing() * 2,
        flex: 'auto',
        overflowX: 'hidden',
        overflowY: 'auto',
      },
      question: {
        // fontWeight: 'bold',
        marginBottom: 8,
      },
      text: {
        padding: theme.spacing() * 2,
        borderRadius: 8,
        backgroundColor: '#F8F9F7',
      }
    }),
  {
    name: 'Resposta',
  }
);
